import { NextRouter, useRouter } from 'next/router';

type UpdateRouterOptions = {
  shouldReplaceHistory: boolean;
  scrollToTopOfPage: boolean;
};

type RemoveAllQueryParams = {
  listingAlias: string;
  shouldReplaceHistory?: boolean;
  scrollToTopOfPage?: boolean;
};

type UpdateQueryParams = {
  queryParamValues: Record<string, string | string[] | null>;
  shouldReplaceHistory?: boolean;
  scrollToTopOfPage?: boolean;
};

export default () => {
  const router = useRouter();

  const updateRouter = (
    updatedRouter: Pick<NextRouter, 'pathname' | 'query'>,
    { shouldReplaceHistory, scrollToTopOfPage }: UpdateRouterOptions,
  ) => {
    return shouldReplaceHistory
      ? router.replace(updatedRouter, undefined, { scroll: scrollToTopOfPage, shallow: true })
      : router.push(updatedRouter, undefined, { scroll: scrollToTopOfPage, shallow: true });
  };

  const removeAllQueryParams = ({
    listingAlias,
    shouldReplaceHistory = false,
    scrollToTopOfPage = false,
  }: RemoveAllQueryParams) => {
    return updateRouter(
      { pathname: '/lead-management/[listingAlias]', query: { listingAlias } },
      { shouldReplaceHistory, scrollToTopOfPage },
    );
  };

  const updateQueryParams = ({
    queryParamValues,
    shouldReplaceHistory = false,
    scrollToTopOfPage = false,
  }: UpdateQueryParams) => {
    const existingQueryParams = { ...router.query };
    Object.entries(queryParamValues).map(async ([key, value]) => {
      if (value === null) {
        delete existingQueryParams[key];
      } else {
        existingQueryParams[key] = value;
      }
    });

    const updatedRouter = {
      pathname: router.pathname,
      query: existingQueryParams,
    };

    return updateRouter(updatedRouter, { shouldReplaceHistory, scrollToTopOfPage });
  };

  return {
    removeAllQueryParams,
    updateQueryParams,
  };
};
